"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { useLocale } from "next-intl";
import { cn } from "@/lib/utils";

interface PartnerNameLinkProps {
  name?: string;
  /** 없으면 링크 대신 평문으로 렌더한다 (구형 쿼리 경로 대비). */
  slug?: string | null;
  /** 카드 변형별 타이포 (크기·굵기·색). leading 을 반드시 함께 지정할 것. */
  className?: string;
}

/**
 * 상품 카드의 파트너명 — 파트너 스토어로 가는 독립 링크.
 *
 * 카드 루트는 상품 링크가 `after:absolute after:inset-0` 으로 통째로 덮고 있다
 * (stretched link). 이 링크는 `relative z-10` 으로 그 위에 올라타야 클릭이 먹는다.
 *
 * **카드 루트는 반드시 `div` + `relative` 여야 한다.** 루트가 `<Link>` 이면
 * 중첩 `<a>` 가 되어 브라우저가 DOM 을 쪼갠다.
 */
export function PartnerNameLink({ name, slug, className }: PartnerNameLinkProps) {
  const locale = useLocale();

  if (!name) return null;

  const base = cn("flex items-center gap-0.5 min-w-0 max-w-full", className);

  if (!slug) {
    return (
      <p className={base}>
        <span className="truncate">{name}</span>
      </p>
    );
  }

  return (
    <Link
      href={`/${locale}/partner/${slug}`}
      className={cn(base, "relative z-10 w-fit hover:underline underline-offset-2")}
    >
      <span className="truncate">{name}</span>
      <ChevronRight className="w-3 h-3 shrink-0 text-gray-400" aria-hidden />
    </Link>
  );
}

export default PartnerNameLink;
